import React from "react";

/**
 * The empty, loading and error state for a table. Lifted out of AdminPage so the pass-collection
 * screen shows the same thing rather than growing its own near-copy.
 */
function TableState({ icon, title, message, children }) {
  return (
    <div className="hm-tstate">
      <span className="hm-tstate-ico" aria-hidden="true">
        <i className={icon}></i>
      </span>
      <strong>{title}</strong>
      {message && <p>{message}</p>}
      {children}
    </div>
  );
}

export default TableState;
